import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../shared/shared.module';

import { CostEstimatorComponent } from './cost-estimator.component';
import { CostEstimate } from './models/estimate.model';
import { CostEstimatorService } from './services/cost-estimator.service';
import { AccountModule } from '../account/account.module';
import { ShipServiceEstimateComponent } from './ship-service-estimate/ship-service-estimate.component';
import { ShipmentService } from '../ship/services/shipment.service';


@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        FormsModule,
        AccountModule,
        SharedModule,
    ],
    declarations: [
        CostEstimatorComponent,
        ShipServiceEstimateComponent,
    ],
    providers: [
        CostEstimate,
        CostEstimatorService,
        ShipmentService,
    ]
})
export class CostEstimatorModule {

}
